import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationSummaryRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-summary',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation',
};
